<template lang="pug">
v-app
  section
    header.d-flex.row.flex-row.align-items-center.mb-5
      .col
        h1.m-0.font-italic.d-inline-block.align-middle
          | Histórico&nbsp;
          span.ad_text-secondary {{user.name}}
      .col-2.text-center
        .ad_select.w-100
          select(v-model="year", @change='changeYear($event)')
            option(:value="null" disabled) Selecciona Año
            option(:value="n" v-for="n in years") {{n}}
      .col-2.text-center
        .ad_select.w-100
          select(v-model="month", @change='changeMonth($event)')
            option(:value="null" disabled) Selecciona Mes
            option(:value="n" v-for="n in months") {{meses[n-1]}}

    section
      .d-flex.row.flex-row.align-items-start.mt-4
        .col
          .card.p-0.ad_border2-primaryLight.rounded-xl
            .card-body
              .col.ad_bg-gray.rounded-lg.py-4
                table.w-100.text-left.table-rounded-body.espacing-table
                  tr
                    td(rowspan=2)
                    th.text-center.font-weight-bold(v-for="(week, index) in weeksNumbers" width="16%" colspan="5" scope="colgroup" v-if="index <=weeksNumbers.length && index <=4")
                      | Semana {{ week}}
                  tr
                    //Semana 1
                    th.text-center.font-weight-bold( scope="col" v-if="1 <=weeksNumbers.length")
                      | PS
                    th.text-center.font-weight-bold( scope="col" v-if="1 <=weeksNumbers.length")
                      | DDD
                    th.text-center.font-weight-bold( scope="col" v-if="1 <=weeksNumbers.length")
                      | CP
                    th.text-center.font-weight-bold( scope="col" v-if="1 <=weeksNumbers.length")
                      | SDA
                    th.text-center.font-weight-bold( scope="col" style="border-right: 1px solid #000;" v-if="1 <=weeksNumbers.length")
                      | SDB
                    //Semana 2  
                    th.text-center.font-weight-bold( scope="col" style="border-left: 1px solid #000;" v-if="2 <=weeksNumbers.length")
                      | PS
                    th.text-center.font-weight-bold( scope="col" v-if="2 <=weeksNumbers.length")
                      | DDD
                    th.text-center.font-weight-bold( scope="col" v-if="2 <=weeksNumbers.length")
                      | CP
                    th.text-center.font-weight-bold( scope="col" v-if="2 <=weeksNumbers.length")
                      | SDA
                    th.text-center.font-weight-bold( scope="col" style="border-right: 1px solid #000;" v-if="2 <=weeksNumbers.length")
                      | SDB
                    //Semana 3
                    th.text-center.font-weight-bold( scope="col" style="border-left: 1px solid #000;" v-if="3 <=weeksNumbers.length")
                      | PS
                    th.text-center.font-weight-bold( scope="col" v-if="3 <=weeksNumbers.length")
                      | DDD
                    th.text-center.font-weight-bold( scope="col" v-if="3 <=weeksNumbers.length")
                      | CP
                    th.text-center.font-weight-bold( scope="col" v-if="3 <=weeksNumbers.length")
                      | SDA
                    th.text-center.font-weight-bold( scope="col" style="border-right: 1px solid #000;" v-if="3 <=weeksNumbers.length")
                      | SDB
                    //Semana 4
                    th.text-center.font-weight-bold( scope="col" style="border-left: 1px solid #000;" v-if="4 <=weeksNumbers.length")
                      | PS
                    th.text-center.font-weight-bold( scope="col" v-if="4 <=weeksNumbers.length")
                      | DDD
                    th.text-center.font-weight-bold( scope="col" v-if="4 <=weeksNumbers.length")
                      | CP
                    th.text-center.font-weight-bold( scope="col" v-if="4 <=weeksNumbers.length")
                      | SDA
                    th.text-center.font-weight-bold( scope="col" style="border-right: 1px solid #000;" v-if="4 <=weeksNumbers.length")
                      | SDB
                    //Semana 5
                    th.text-center.font-weight-bold( scope="col" style="border-left: 1px solid #000;" v-if="5 <=weeksNumbers.length")
                      | PS
                    th.text-center.font-weight-bold( scope="col" v-if="5 <=weeksNumbers.length")
                      | DDD
                    th.text-center.font-weight-bold( scope="col" v-if="5 <=weeksNumbers.length")
                      | CP
                    th.text-center.font-weight-bold( scope="col" v-if="5 <=weeksNumbers.length")
                      | SDA
                    th.text-center.font-weight-bold( scope="col" v-if="5 <=weeksNumbers.length")
                      | SDB
                  tbody
                    tr(v-for="(collaborator, index) in collabs")       
                      td
                        div.justify-content-center
                          | {{collaborator.name}}
                      //Semana 1
                      td(v-if="1 <=collaborator.weeks.length")
                        div.justify-content-center
                          | {{collaborator.weeks[0].PS}} %
                      td(v-if="1 <=collaborator.weeks.length")
                        div.justify-content-center
                          | {{collaborator.weeks[0].DDD}} %
                      td(v-if="1 <=collaborator.weeks.length")
                        div.justify-content-center
                          | {{collaborator.weeks[0].CP}} %
                      td(v-if="1 <=collaborator.weeks.length")
                        div.justify-content-center
                          | {{collaborator.weeks[0].SDA}} %
                      td(v-if="1 <=collaborator.weeks.length" style="border-right: 1px solid #000;")
                        div.justify-content-center
                          | {{collaborator.weeks[0].SDB}} %    
                      //Semana 2
                      td(v-if="2 <=collaborator.weeks.length" style="border-left: 1px solid #000;")
                        div.justify-content-center
                          | {{collaborator.weeks[1].PS}} %
                      td(v-if="2 <=collaborator.weeks.length")
                        div.justify-content-center
                          | {{collaborator.weeks[1].DDD}} %
                      td(v-if="2 <=collaborator.weeks.length")
                        div.justify-content-center
                          | {{collaborator.weeks[1].CP}} %
                      td(v-if="2 <=collaborator.weeks.length")
                        div.justify-content-center
                          | {{collaborator.weeks[1].SDA}} %
                      td(v-if="2 <=collaborator.weeks.length" style="border-right: 1px solid #000;")
                        div.justify-content-center
                          | {{collaborator.weeks[1].SDB}} %  
                      //Semana 3
                      td(v-if="3 <=collaborator.weeks.length" style="border-left: 1px solid #000;")
                        div.justify-content-center
                          | {{collaborator.weeks[2].PS}} %
                      td(v-if="3 <=collaborator.weeks.length")
                        div.justify-content-center
                          | {{collaborator.weeks[2].DDD}} %
                      td(v-if="3 <=collaborator.weeks.length")
                        div.justify-content-center
                          | {{collaborator.weeks[2].CP}} %
                      td(v-if="3 <=collaborator.weeks.length")
                        div.justify-content-center
                          | {{collaborator.weeks[2].SDA}} %
                      td(v-if="3 <=collaborator.weeks.length" style="border-right: 1px solid #000;")
                        div.justify-content-center
                          | {{collaborator.weeks[2].SDB}} %  
                      //Semana 4
                      td(v-if="4 <=collaborator.weeks.length" style="border-left: 1px solid #000;")
                        div.justify-content-center
                          | {{collaborator.weeks[3].PS}} %
                      td(v-if="4 <=collaborator.weeks.length")
                        div.justify-content-center
                          | {{collaborator.weeks[3].DDD}} %
                      td(v-if="4 <=collaborator.weeks.length")
                        div.justify-content-center
                          | {{collaborator.weeks[3].CP}} %
                      td(v-if="4 <=collaborator.weeks.length")
                        div.justify-content-center
                          | {{collaborator.weeks[3].SDA}} %
                      td(v-if="4 <=collaborator.weeks.length" style="border-right: 1px solid #000;")
                        div.justify-content-center
                          | {{collaborator.weeks[3].SDB}} %  
                      //Semana 5
                      td(v-if="5 <=collaborator.weeks.length" style="border-left: 1px solid #000;")
                        div.justify-content-center
                          | {{collaborator.weeks[4].PS}} %
                      td(v-if="5 <=collaborator.weeks.length")
                        div.justify-content-center
                          | {{collaborator.weeks[4].DDD}} %
                      td(v-if="5 <=collaborator.weeks.length")
                        div.justify-content-center
                          | {{collaborator.weeks[4].CP}} %
                      td(v-if="5 <=collaborator.weeks.length")
                        div.justify-content-center
                          | {{collaborator.weeks[4].SDA}} %
                      td(v-if="5 <=collaborator.weeks.length")
                        div.justify-content-center
                          | {{collaborator.weeks[4].SDB}} %   
                  tfoot
                    tr
                      td
                        div.justify-content-center
                          | Promedios 
                      //Semana 1
                      td(v-if="1 <=totals.length")
                        div.justify-content-center
                          | {{totals[0].PS}} %
                      td(v-if="1 <=totals.length")
                        div.justify-content-center
                          | {{totals[0].DDD}} %
                      td(v-if="1 <=totals.length")
                        div.justify-content-center
                          | {{totals[0].CP}} %
                      td(v-if="1 <=totals.length")
                        div.justify-content-center
                          | {{totals[0].SDA}} %
                      td(v-if="1 <=totals.length" style="border-right: 1px solid #000;")
                        div.justify-content-center
                          | {{totals[0].SDB}} %    
                      //Semana 2
                      td(v-if="2 <=totals.length" style="border-left: 1px solid #000;")
                        div.justify-content-center
                          | {{totals[1].PS}} %
                      td(v-if="2 <=totals.length")
                        div.justify-content-center
                          | {{totals[1].DDD}} %
                      td(v-if="2 <=totals.length")
                        div.justify-content-center
                          | {{totals[1].CP}} %
                      td(v-if="2 <=totals.length")
                        div.justify-content-center
                          | {{totals[1].SDA}} %
                      td(v-if="2 <=totals.length" style="border-right: 1px solid #000;")
                        div.justify-content-center
                          | {{totals[1].SDB}} % 
                      //Semana 3
                      td(v-if="3 <=totals.length" style="border-left: 1px solid #000;")
                        div.justify-content-center
                          | {{totals[2].PS}} %
                      td(v-if="3 <=totals.length")
                        div.justify-content-center
                          | {{totals[2].DDD}} %
                      td(v-if="3 <=totals.length")
                        div.justify-content-center
                          | {{totals[2].CP}} %
                      td(v-if="3 <=totals.length")
                        div.justify-content-center
                          | {{totals[2].SDA}} %
                      td(v-if="3 <=totals.length" style="border-right: 1px solid #000;")
                        div.justify-content-center
                          | {{totals[2].SDB}} % 
                      //Semana 4
                      td(v-if="4 <=totals.length" style="border-left: 1px solid #000;")
                        div.justify-content-center
                          | {{totals[3].PS}} %
                      td(v-if="4 <=totals.length")
                        div.justify-content-center
                          | {{totals[3].DDD}} %
                      td(v-if="4 <=totals.length")
                        div.justify-content-center
                          | {{totals[3].CP}} %
                      td(v-if="4 <=totals.length")
                        div.justify-content-center
                          | {{totals[3].SDA}} %
                      td(v-if="4 <=totals.length" style="border-right: 1px solid #000;")
                        div.justify-content-center
                          | {{totals[3].SDB}} %   
                      //Semana 5
                      td(v-if="5 <=totals.length" style="border-left: 1px solid #000;")
                        div.justify-content-center
                          | {{totals[4].PS}} %
                      td(v-if="5 <=totals.length")
                        div.justify-content-center
                          | {{totals[4].DDD}} %
                      td(v-if="5 <=totals.length")
                        div.justify-content-center
                          | {{totals[4].CP}} %
                      td(v-if="5 <=totals.length")
                        div.justify-content-center
                          | {{totals[4].SDA}} %
                      td(v-if="5 <=totals.length")
                        div.justify-content-center
                          | {{totals[4].SDB}} %   
                      
</template>

<script>
import moment from "moment";
import { mapActions } from "vuex";

export default {

  name: 'Historico',

  data () {
    return {
      user: {},
      year: null,
      years: [],
      month:null,
      months: [],
      weeksNumbers : [],
      collabs : [],
      totals: [],
      meses : [
            "Enero",
            "Febrero",
            "Marzo",
            "Abril",
            "Mayo",
            "Junio",
            "Julio",
            "Agosto",
            "Septiembre",
            "Octubre",
            "Noviembre",
            "Diciembre",
        ]
    }
  },
  methods: {
    moment,
    ...mapActions("user", ["getUserById"]),
    ...mapActions("consultant", ["getAnsweredGuidelinesHistory"]),
    getHistorical() {
      const vm = this;
      const user_evaluated = vm.$store.state.auth.user.id
      const loading = vm.$toast.loading("Cargando semanas...");      
      vm.getUserById(user_evaluated).then(response => {
        vm.user = response;
        const year = vm.year ? vm.year : 2019;
        const month = vm.month;
        const data = {
          user_evaluated,
          year, 
          month
        };
        vm.getAnsweredGuidelinesHistory(data).then(guidelines => { 
          vm.weeksNumbers = guidelines.weeksNumber;
          vm.collabs = guidelines.evaluatedUsers;
          vm.totals = guidelines.totals;
        });
      });
      loading.hide();
    },
    changeYear($event) {
      const vm = this;
      vm.getMonths();
      vm.getHistorical();
    },
    changeMonth($event) {
      const vm = this;
      vm.getHistorical();
    },
    getYears() {
      const vm = this;
      let currentYear = new Date().getFullYear();
      if(!vm.year) {
        vm.year = currentYear;
      }
      let startYear = 2019;
      let yearslist = [];  
      while ( startYear <= currentYear ) {
          yearslist.push(startYear++);
      }   
      vm.years = yearslist;
    },
    getMonths() {
      const vm = this;
      
      let startMonth = 1;
      let endMonth = new Date().getFullYear() == vm.year ? new Date().getMonth() + 1 : 12;
      if(!vm.month) {
        vm.month = endMonth;
      }
      let monthlist = [];  
      while ( startMonth <= endMonth ) {
          monthlist.push(startMonth++);
      }   
      
      vm.months = monthlist;
    }
  },
  mounted() {
    this.$nextTick(() => {
      const vm = this;
      vm.getYears();
      vm.getMonths();
      vm.getHistorical();
    })  
  }
}
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// src/views/historico.vue